<style scoped>
.de-iframe{
    width: 100%;
    height: 100%;
}
</style>
<template>
    <div class="de-iframe">
        <iframe :src="alink" :width="getWidth" :height="getHeight" scrolling="no" frameborder="0"></iframe>
    </div>
</template>
<script>
export default {
    name: 'deIframe',
    props: {
        link: {
            type: String,
            default: ''
        },
        width: {
            type:  [Number,String],
            default: 100
        },
        height: {
            type:[String,Number],
            default: 100
        }
    },
    data(){
        return {
            alink: this.link
        }
    },
    watch: {
        link(){
            this.alink = this.link;
        }
    },
    computed: {
        getWidth(){
            return this.width <= 100 ? this.width + '%' : this.width + 'px'
        },
        getHeight(){
            return this.height <= 100 ? this.height + '%' : this.height + 'px'
        }
    },
    methods: {
       updateIframeLink(url){
           this.alink = url;
       }
    }
}
</script>